var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapGridArea"},[_c('div',{staticClass:"title"},[_vm._v("DB Paging 처리")]),_c('div',{staticStyle:{"width":"100%","height":"400px"},attrs:{"id":"gridArea"}}),_c('SBGrid',{ref:"grid",attrs:{"id":"grid","data":_vm.gridJson,"columns":_vm.grid1columns,"gridattr":{
      rowheader: 'seq',
      rowheadercaption : {seq: '순번'},
      rowheaderwidth: {seq: '80'},
      showtotalrows:true,
      paging: {
        'type' : 'page',
        'count' : 5,
        'size' : 5,
        'sorttype' : 'page',
        'showgoalpageui' : true
      },}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }